<template>
    <div class="news-course">
        <!-- <newsHeader :page="'优秀课程'"></newsHeader> -->
        <!-- <breadCrumb></breadCrumb> -->
        <router-view></router-view>
        <scorllTop></scorllTop>
        <!-- <div class="footer-section">
            <footer-view></footer-view>
        </div> -->
    </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
    @import "../less/news_common.less";
    
    .news-course {
        background-color: #fff;
        // min-height: 100vh;
        min-height: calc(100vh - 394px);
        height: auto !important;
        height: 100vh; /*IE6不识别min-height*/
        position: relative;
        padding-bottom: 50px;
        box-sizing: border-box;

        .course-list {
            padding-top: 21px;
        }

        .footer-section {
            width: 100%;
            position: absolute;
            bottom: 0;
            overflow: hidden;
            max-height: 310px;
        }
    }
    
</style>